import axiosInstance from "../AxiosInstance";
// Get Admin Users
export function getPanchkarmaUsers(pagination, pageid,search_by = "", search_keyword = "",sort_by = "",sort_order="") {
  return axiosInstance.post("/panchkarma/users/list", { pagination, pageid ,    search_by, search_keyword,sort_by,sort_order});
}

// Add Admin User
export function addPanchkarmaUser(userData) {
  return axiosInstance.post("/panchkarma/users/add", userData);
}

// ✅ Update Admin User
export function updatePanchkarmaUser(userData) {
  return axiosInstance.post("/panchkarma/users/edit", userData);
}

// ✅ Delete Admin User
export function deletePanchkarmaUser(userData) {
  console.log("deletePanchkarmaUser payload:", userData);
  return axiosInstance.post("/panchkarma/users/delete", userData);
}

// ✅ Format Admin Users
export function formatPanchkarmaUsers(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((user) => ({
      ...user,
      admin_id: user.admin_id || user._id || user.id,
    }));
  }

  let users = [];
  for (let key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      users.push({
        ...responseData[key],
        admin_id:
          responseData[key].admin_id ||
          responseData[key]._id ||
          responseData[key].id ||
          key,
      });
    }
  }
  return users;
}
